let share = {
    params: {
        location: 'no',
        menubar: 'no',
        scrollbars: 'no',
        status: 'no',
        titlebar: 'no',
        toolbar: 'no'
    },
    url: window.location.href,
    win: null,

    init: function () {
        $('[data-share-facebook]').on('click', this.onShareFacebook.bind(this))
        $('[data-share-twitter]').on('click', this.onShareTwitter.bind(this))
    },

    onShareFacebook(e) {
        let params

        e.preventDefault()

        params = $.extend(this.params, {
            height: 450,
            left: Math.round(($(window).width() - 555) * 0.5),
            top:  Math.round(($(window).height() - 450) * 0.5),
            width: 555,
        })

        this.openWindow(`http://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.url)}`)
    },

    onShareTwitter(e) {
        let params

        e.preventDefault()

        params = $.extend(this.params, {
            height: 250,
            left: Math.round(($(window).width() - 555) * 0.5),
            top:  Math.round(($(window).height() - 250) * 0.5),
            width: 555,
        });

        this.openWindow(`http://twitter.com/intent/tweet?related=ufomeldpuntnl&text=${encodeURI(document.title)}&url=${encodeURI(this.url)}`)
    },

    openWindow(url) {
        this.win = window.open(
            url,
            'share',
            $.param(params).replace(/&/g, ','),
            true
        );
    }
}

export default share